export default "__VITE_ASSET__BCGRDfBC__"